/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Details/Services/ScrollEndDetectionService" />
import { IVssService, VssService, Services } from "VSS/Platform/Context";

export interface IScrollEndDetectionService extends IVssService {
    isAtTheBottom(target: HTMLDivElement): boolean;
}

export const ScrollEndDetectionServiceName = "IScrollEndDetectionService";

export class ScrollEndDetectionService extends VssService implements IScrollEndDetectionService {

    private readonly _limit: number;

    constructor(limit?: number) {
        super();

        if (limit === undefined) {
            limit = 50;
        }

        this._limit = limit;
    }

    public isAtTheBottom(target: HTMLDivElement): boolean {
        if (!target) {
            return false;
        }

        const remainingScrollHeight = Math.abs(target.scrollHeight - Math.round(target.scrollTop) - target.clientHeight);
        return remainingScrollHeight < this._limit;
    }
}

Services.add(ScrollEndDetectionServiceName, { serviceFactory: ScrollEndDetectionService });